import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import FormsList from './pages/FormsList';
// import FormBuilder from './pages/FormBuilder';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import routes from "./routes.json";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Routes>
      {routes.map(route => (
        <Route key={route.slug} path={`form/v2/:slug`} element={<App />} />
      ))}
      <Route path={`form/v2/k845kdka`} element={<FormsList />} />
      {
        (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ?
        <>
          {/* <Route path={`form/v2/up3zipkt/:slug`} element={<FormBuilder />} /> */}
          <Route path={`form/v2`} element={<FormsList />} />
        </>
          : null
      }
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 